import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { OrderService } from 'app/main/orders/order.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BillingDetails } from 'app/main/orders/new-order/order.model';
import { MatTableDataSource } from '@angular/material/table';
import * as XLSX from 'xlsx';
@Component({
    selector: 'order-manifest',
    templateUrl: './order-manifest.component.html',
    styleUrls: ['./order-manifest.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class OrderManifestComponent implements OnInit, OnDestroy {
    fromDate: Date = new Date();
    toDate: Date = new Date();
    selectedStatus: string = 'View All';
    selectedShipper: string = 'View All';
    selectedDestination: string = 'View All';
    statuses = [
        { value: 'View All', label: 'View All' },
        { value: 'Order Processed', label: 'Order Processed' },
        { value: 'Shipment in transit', label: 'Shipment in transit' },
        { value: 'Shipment Manifested', label: 'Shipment Manifested' },
        { value: 'Shipment Collected', label: 'Shipment Collected' },
        { value: 'Arrived at Net Facility', label: 'Arrived at Net Facility' },
        { value: 'Shipment on hold', label: 'Shipment on hold' },
        { value: 'Out for delivery', label: 'Out for delivery' },
        { value: 'Delivered to final destination', label: 'Delivered to final destination' },
        { value: 'Shipment not delivered', label: 'Shipment not delivered' },
        { value: 'Shipment Processed', label: 'Shipment Processed' },
        { value: 'Shipment not collected', label: 'Shipment not collected' }
    ];
    displayedColumns = ['label', 'shipper', 'origin', 'receiver', 'destination', 'weight', 'nop', 'status'];
    dataSource: MatTableDataSource<OrderManifest> = new MatTableDataSource<OrderManifest>();
    ELEMENT_DATA: OrderManifest[] = [];

    fromDateFormatted;
    toDateFormatted;
    minDate  : Date = new Date();
    shippers: string[] = [];
    destinations: string[] = [];

    @ViewChild('table', { static: false }) table: ElementRef;

    orders: any[] = [];
    billingDetails: BillingDetails = new BillingDetails();
    showProgressBar: boolean = false;

    group: FormGroup;
    // Private
    private _unsubscribeAll: Subject<any>;
    /**
     * Constructor
     *
     * @param {InvoiceService} _invoiceService
     */
    constructor(private _formBuilder: FormBuilder, private _orderService: OrderService) {

        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.fromDate.setHours(0, 0, 0);

        this.toDate.setHours(23, 59, 0);

        console.log("this.fromDate: " + this.fromDate)
        console.log("this.toDate: " + this.toDate)

        this._orderService.getMyInfo().subscribe((info: BillingDetails) => {
            this.billingDetails = info;
        });
        this.group = this._formBuilder.group({
            fromDate: ['', [Validators.required]],
            toDate: ['', [Validators.required]],
        });
        this.group.get('fromDate').setValue(this.fromDate);
        this.fromDateFormatted = this.fromDate.toJSON().slice(0, 10).replace(/-/g, '/');
        console.log("this.fromDateFormatted: " + this.fromDateFormatted)

        this.group.get('toDate').setValue(this.toDate);
        this.toDateFormatted = this.toDate.toJSON().slice(0, 10).replace(/-/g, '/');
        console.log("this.toDateFormatted: " + this.toDateFormatted)
        this.group.get('fromDate').valueChanges.subscribe(value => {
            this.showProgressBar = true;
            // this.fromDate = value;
            this.fromDateFormatted = new Date(value.getTime() - (value.getTimezoneOffset() * 60000)).toJSON().slice(0, 10).replace(/-/g, '/');
            console.log("this.fromDateFormatted new Date(): " + this.fromDateFormatted)

            this._orderService.getOrderManifest(value, this.toDateFormatted).subscribe(orders => {
                this.ELEMENT_DATA = [];
                const shipperSet = new Set<string>();
                const destinationSet = new Set<string>();
                this.orders = orders;
                this.orders.forEach(x => {
                    this.ELEMENT_DATA.push(x);
                    if (x.shipper) {
                        shipperSet.add(x.shipper);
                    }
                    if (x.destination) {
                        destinationSet.add(x.destination)
                    }
                });
                this.shippers = ['View All', ...Array.from(shipperSet)];
                this.destinations = ['View All', ...Array.from(destinationSet)];
                this.dataSource.data = this.ELEMENT_DATA;
                this.showProgressBar = false;
                // this.minDate = value;
            });
        });
        this.group.get('toDate').valueChanges.subscribe(value => {
            this.showProgressBar = true;
            // this.toDate = value;
            this.toDateFormatted = new Date(value.getTime() - (value.getTimezoneOffset() * 60000)).toJSON().slice(0, 10).replace(/-/g, '/');
            console.log("this.toDateFormatted new Date(): " + this.toDateFormatted)
            this._orderService.getOrderManifest(this.fromDateFormatted, value).subscribe(orders => {
                this.ELEMENT_DATA = [];
                const shipperSet = new Set<string>();
                const destinationSet = new Set<string>();
                this.orders = orders;
                this.orders.forEach(x => {
                    this.ELEMENT_DATA.push(x);
                    if (x.shipper) {
                        shipperSet.add(x.shipper);
                    }
                    if (x.destination) {
                        destinationSet.add(x.destination)
                    }
                });
                this.shippers = ['View All', ...Array.from(shipperSet)];
                this.destinations = ['View All', ...Array.from(destinationSet)];
                this.dataSource.data = this.ELEMENT_DATA;
                this.showProgressBar = false;
            });
        });

        this._orderService.getOrderManifest(this.fromDate, this.toDate).subscribe(orders => {
            this.ELEMENT_DATA = [];
            const shipperSet = new Set<string>();
                const destinationSet = new Set<string>();
            this.fromDateFormatted = this.fromDate.toJSON().slice(0, 10).replace(/-/g, '/');
            this.orders = orders;
            this.orders.forEach(x => {
                this.ELEMENT_DATA.push(x);
                if (x.shipper) {
                        shipperSet.add(x.shipper);
                    }
                    if (x.destination) {
                        destinationSet.add(x.destination)
                    }
            });
            this.shippers = ['View All', ...Array.from(shipperSet)];
            this.destinations = ['View All', ...Array.from(destinationSet)];
            this.dataSource.data = this.ELEMENT_DATA;
            this.showProgressBar = false;

        });

    }
    ngAfterViewInit(): void {
    }
    onPrint() {
        window.print();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    exportAsExcel() {

        const ws = XLSX.utils.json_to_sheet(this.dataSource.data);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        var sheetName = 'Manifest --' + this.fromDate.toJSON().slice(0, 10).replace(/-/g, '/') + ' - ' + this.toDate.toJSON().slice(0, 10).replace(/-/g, '/') + '.xlsx'
        /* save to file */
        XLSX.writeFile(wb, sheetName);

    }

    applyFilters(): void {
        let toFilter = this.ELEMENT_DATA;

        if (this.selectedShipper !== 'View All') {
            toFilter = toFilter.filter(x => x.shipper === this.selectedShipper);
        }

        if (this.selectedDestination !== 'View All') {
            toFilter = toFilter.filter(x => x.destination === this.selectedDestination);
        }

        if (this.selectedStatus !== 'View All') {
            toFilter = toFilter.filter(x => x.status === this.selectedStatus);
        }

        this.dataSource.data = toFilter;
    }


}
export class OrderManifest {
    label: string;
    shipper: string;
    origin: string;
    receiver: string;
    destination: string;
    type: string;
    weight: number;
    nop: number;
    shipmentValue: number
    status: string
    constructor(order?) {
        order = order || {};
        this.label = order.label;
        this.shipper = order.shipper;
        this.origin = order.origin;
        this.receiver = order.receiver || '';
        this.destination = order.destination;
        this.type = order.type;
        this.weight = order.weight;
        this.nop = order.nop;
        this.shipmentValue = order.shipmentValue;
        this.status = order.status;
}
}